import { createContext, useContext } from 'react';

import { type UpdatedTariffModalContextState } from '../types';

const UpdatedTariffModalContext =
  createContext<Nullable<UpdatedTariffModalContextState>>(null);

const useUpdatedTariffModalContext = () => {
  const context = useContext(UpdatedTariffModalContext);
  if (!context) {
    throw new Error(
      'useUpdatedTariffModalContext must be used within an UpdatedTariffModalProvider'
    );
  }
  return context;
};

export { UpdatedTariffModalContext, useUpdatedTariffModalContext };
